import { Outlet, Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { URLRoutes } from "enums/Routing";
import { Auth, IsBillingCompany } from "recoil-states/auth-states";

// route available only when not logged in
const GuestRoute = () => {
  const auth = useRecoilValue(Auth);
  const isBillingCompany = useRecoilValue(IsBillingCompany);

  // Redirect based on user type
  const redirectTo = isBillingCompany
    ? URLRoutes.BillingDashboard
    : URLRoutes.AccountDashboard;

  return auth ? <Navigate to={redirectTo} /> : <Outlet />;
};

export default GuestRoute;
